import _classPrivateFieldInitSpec from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/defineProperty.js";
import _classPrivateFieldGet2 from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/classPrivateFieldGet2.js";
import _classPrivateFieldSet2 from "../_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/classPrivateFieldSet2.js";
import { isNumber } from "es-toolkit";
var SLOT_BASE = 2 ** 22;
var FNV_OFFSET_BASIS = 2166136261;
var FNV_PRIME = 16777619;
function slotOf(editorId) {
	let hash = FNV_OFFSET_BASIS;
	for (let index = 0; index < editorId.length; index++) {
		hash ^= editorId.charCodeAt(index);
		hash = Math.imul(hash, FNV_PRIME);
	}
	return hash & SLOT_BASE - 1;
}
var _version = /* @__PURE__ */ new WeakMap();
var _slot = /* @__PURE__ */ new WeakMap();
var Clock = class {
	constructor() {
		_classPrivateFieldInitSpec(this, _version, 0);
		_classPrivateFieldInitSpec(this, _slot, 0);
		_defineProperty(this, "getVersion", () => {
			return _classPrivateFieldGet2(_version, this);
		});
		_defineProperty(this, "getNextVersion", () => {
			return (Math.floor(this.getVersion() / SLOT_BASE) + 1) * SLOT_BASE + _classPrivateFieldGet2(_slot, this);
		});
		_defineProperty(this, "setSlot", (slot) => {
			if (Number.isInteger(slot) && 0 <= slot && slot < SLOT_BASE) _classPrivateFieldSet2(_slot, this, slot);
			return this;
		});
		_defineProperty(this, "merge", (remoteVersion) => {
			if (!isNumber(remoteVersion) || !Number.isInteger(remoteVersion)) return this;
			if (this.getVersion() < remoteVersion) _classPrivateFieldSet2(_version, this, remoteVersion);
			return this;
		});
	}
};
//#endregion
export { Clock, SLOT_BASE, slotOf };
